import { TypedUseSelectorHook, useSelector } from "react-redux";
// Adjust this path if your RootState is exported from a different file (e.g., ../store/index)
import { RootState } from "../store"; // Changed from "../store/reducers"

// Use throughout your app instead of plain `useDispatch` and `useSelector`
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
